<template>
	<div>
		<router-view></router-view>
		<div id="app"></div>
	</div>
</template>

<script>
	module.exports = {
		name: 'App',
		data: function () {
			return {
				locale: 'en'
			};
		},
		methods: {
		}
	};
</script>



// WEBPACK FOOTER //
// App.vue?5308d1e1